import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions, userActions } from "../../actions";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { formatSqlDate } from "../../helpers";
import { DEBUG_STATE } from "../../constants/constants.js"

function UserDetail(props) {
  const { authentication, org, users, getUserDetail, getAllRoles, getDocTypes } = props;

  const editing_user_org_id = authentication.user.org_id;

  const user_detail = users?.user_detail;
  const user_id = props.match.params.id;
  const roles = users?.roles;

  const assignable_orgs = authentication?.user?.orgs;
  const assignable_org_ids = assignable_orgs?.map((org) => org.org_id);
  const user_org_ids = [];
  if (user_detail) {

    for (const org of user_detail.orgs) {
      user_org_ids.push(org.org_id);
    }

  }


  const userOrgId = user_detail?.org_id;

  const debug = DEBUG_STATE;

  const editicon = require("../../images/editicon.png").default;

  console.log(user_detail);

  const doctypes = org?.doc_types;

  const user_doctypes = user_detail?.doctypes?.map((doctype => doctype.doc_type_name));


  const restrict_ip = (user_detail?.restricted_ips?.[0] !== '*');
  const mfa_type = user_detail?.mfa_type;
  const use_mfa = (user_detail?.mfa_type !== "none");

  useEffect(() => {
    if (userOrgId) {
      getDocTypes(userOrgId);
    }

  }, [userOrgId])

  useEffect(() => {
    getUserDetail(user_id)
  }, [user_id])


  useEffect(() => {
    getAllRoles();
  }, [])

  if (debug) {
    console.log(roles);
    console.log(user_detail)
  };


  const user_roles_html = roles?.map((role, i) => (
    <>
      <tr key={"role-" + role}>
        <td className="formLabel">
          {role.name}
        </td>
        <td className="formInfo">
          {
            (user_detail?.roles?.includes(role.name)) && (
              <input type="checkbox" checked readOnly />
            )
          }
          {
            (!(user_detail?.roles?.includes(role.name))) && (
              <input type="checkbox" disabled />
            )
          }
        </td>
      </tr>
    </>
  ));

  const user_orgs_html = assignable_orgs?.map((org, i) => (
    <>
      <tr key={"org-" + org.org_id}>
        <td className="formLabel">
          {org.display_name}
        </td>
        <td className="formInfo">
          {
            (user_org_ids?.includes(org.org_id)) && (
              <input type="checkbox" checked readOnly />
            )
          }
          {
            (!(user_org_ids?.includes(org.org_id))) && (
              <input type="checkbox" disabled />
            )
          }
        </td>
      </tr>
    </>
  ));



  const doctypes_html = doctypes?.map((doctype, i) => (
    <tr key={"doctype-" + doctype}>
      <td className="formLabel">{doctype.doc_type_name}</td>
      <td className="formInfo">
        {
          user_doctypes?.includes(doctype.doc_type_name) && (<input type="checkbox" checked readOnly />)
        }
        {
          !(user_doctypes?.includes(doctype.doc_type_name)) && (<input type="checkbox" disabled />)
        }
      </td>
    </tr>
  ));


  return (
    <div className="searchMain">
      <div className="contentContainerLeftNav">
        <div className="rightContent">
          {user_detail && (
            <>
              <h3>
                {user_detail?.first_name + " " + user_detail?.last_name}
                &nbsp;&nbsp;&nbsp;
                {
                  (assignable_orgs?.map(org => org.org_id).includes(user_detail.org_id)) &&
                  <>
                    <div className="editJacketNameIcon" data-tip data-for="edit name">
                      <Link
                        to={{
                          pathname: "/users/" + user_detail?.user_id + "/edit",
                          state: { user_to_edit: user_detail },
                        }}
                      >
                        <img src={editicon} width="16px" alt="edit" />
                      </Link>
                    </div>
                    <ReactTooltip id="edit name" place="bottom" effect="solid" data-type="info" delayShow={300}>
                      edit user
                    </ReactTooltip>
                  </>
                }


              </h3>
              <div className="orgDetailTile">
                <div className="orgDetailTileHeader">
                  Contact
                </div>
                <table className="ingestorFormTable">
                  <tbody>
                    <tr>
                      <td class="formLabel">Primary Org:</td>
                      <td class="formInfo">
                        {user_detail?.org_name}
                      </td>
                    </tr>
                    <tr>
                      <td className="formLabel">first name</td>
                      <td className="formInfo">{user_detail?.first_name}</td>
                    </tr>
                    <tr>
                      <td className="formLabel">last name</td>
                      <td className="formInfo">{user_detail?.last_name}</td>
                    </tr>
                    <tr>
                      <td className="formLabel">email</td>
                      <td className="formInfo">{user_detail?.email}</td>
                    </tr>
                    <tr>
                      <td className="formLabel">phone</td>
                      <td className="formInfo">{user_detail?.phone}</td>
                    </tr>
                    <tr>
                      <td className="formLabel">date created</td>
                      <td className="formInfo">{formatSqlDate(user_detail?.create_date)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="orgDetailTile">
                <div className="orgDetailTileHeader">
                  Access
                </div>
                <table className="ingestorFormTable">
                  <tbody>
                    <tr>
                      <td className="formLabel">last login date</td>
                      <td className="formInfo">{formatSqlDate(user_detail?.last_login)}</td>
                    </tr>
                    <tr>
                      <td className="formLabel">active?</td>
                      <td className="formInfo">
                        {
                          user_detail?.active && (<input type="checkbox" checked readOnly />)
                        }
                        {
                          !(user_detail?.active) && (<input type="checkbox" disabled />)
                        }
                      </td>
                    </tr>
                    <tr>
                      <td className="formLabel">restrict ip?</td>
                      <td className="formInfo">
                        {
                          restrict_ip && (<input type="checkbox" checked readOnly />)
                        }
                        {
                          !(restrict_ip) && (<input type="checkbox" disabled />)
                        }
                      </td>
                    </tr>
                    {restrict_ip && (
                      <>
                        <tr>
                          <td className="formLabel">ip address 1</td>
                          <td className="formInfo">
                            <input
                              style={{ width: "100%" }}
                              id="ip_address"
                              name="ip_address"
                              autoComplete="off"
                              value={user_detail?.restricted_ips[0]}
                              readOnly
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="formLabel">ip address 2:</td>
                          <td className="formInfo">
                            <input
                              style={{ width: "100%" }}
                              id="ip_address2"
                              name="ip_address2"
                              autoComplete="off"
                              value={user_detail?.restricted_ips[1]}
                              readOnly
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="formLabel">ip address 3:</td>
                          <td className="formInfo">
                            <input
                              style={{ width: "100%" }}
                              id="ip_address3"
                              name="ip_address3"
                              autoComplete="off"
                              value={user_detail?.restricted_ips[2]}
                              readOnly
                            />
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>


              <div className="orgDetailTile">
                <div className="orgDetailTileHeader">
                  Multi-Factor Authentication (MFA)
                </div>
                <table class="ingestorFormTable">
                  <tbody>
                    <tr>
                      <td className="formLabel">Use MFA?</td>
                      <td className="formInfo">
                        {
                          (use_mfa) && (<input type="checkbox" checked readOnly />)
                        }
                        {
                          (!use_mfa) && (<input type="checkbox" disabled />)
                        }
                      </td>
                    </tr>
                    {use_mfa && (
                      <>
                        <tr>
                          <td className="formLabel">Mfa Type</td>
                          <td className="formInto">
                            <select
                              className="orgDropdown"
                              value={mfa_type}
                              onChange={(e) => onChangeMfaType(e)}
                            >
                              <option key="none" id="none" name="none" value="none">
                                Select an MFA Type
                              </option>
                              <option key={"sms"} id="sms" name="sms" value="sms">
                                sms
                              </option>
                              <option key={"email"} id="email" name="email" value="email">
                                email
                              </option>
                            </select>
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="orgDetailTile">
                <div className="orgDetailTileHeader">
                  Orgs
                </div>
                <table className="ingestorFormTable">
                  <tbody>
                    {user_orgs_html}
                  </tbody>
                </table>
              </div>


              <div className="orgDetailTile">
                <div className="orgDetailTileHeader">
                  Roles
                </div>
                <table className="ingestorFormTable">
                  <tbody>
                    {user_roles_html}
                  </tbody>
                </table>
              </div>


              <div className="orgDetailTile">
                <div className="orgDetailTileHeader">
                  Doc Types
                </div>
                <table className="ingestorFormTable">

                  {user_detail?.use_doctypes && (

                    <tbody>
                      {doctypes_html}
                    </tbody>

                  )}
                  {!(user_detail?.use_doctypes) && (
                    <tbody>
                      <tr>
                        <td colSpan="1">
                          <span className="tileInfoText">
                            Document Type Permissioning not enabled for this user's organization.
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  )}

                </table>
              </div>
            </>

          )}
        </div>

        <br />

      </div>
    </div>

  );
}

function mapStateToProps(state) {
  const { authentication, org, users } = state;
  return {
    authentication,
    org,
    users
  };
}

const actionCreators = {
  getDocTypes: orgActions.getDocTypes,
  getUserDetail: userActions.getUserDetail,
  getAllRoles: userActions.getAllRoles
};

const connectedUserDetail = connect(mapStateToProps, actionCreators)(UserDetail);
export { connectedUserDetail as UserDetail };
